<template>
  <div class="box">
    <!-- 头图 -->
    <div class="headerBg">
      <v-header></v-header>
    </div>

    <!-- down -->
    <div class="down">

      <div class="viewport">
        <!-- bg -->
<!--        <div class="bg-ripple"></div>-->
        <div class="bg-star"></div>
        <div class="bg-right"></div>
        <div class="bg-pro"></div>
        <div class="bg-year"></div>

        <!-- 序言 -->
        <v-preface></v-preface>

        <div
          :class="['product5', 'productScroll' + index]"
          v-for="(item, index) in d"
          :key="index"
        >
          <v-part-2
            v-if="item.type !== '创新奖'"
            :p-title = item.title
            :p-list = item.list
            :p-index = index
          />
          <v-part
            v-else
            :p-title = item.title
            :p-list = item.list
            :p-index = index
          />
        </div>

        <!-- 导航栏 -->
        <div class="nav">
          <img
            class="navImg"
            src="@/assets/pingxuan2024/pc/images/nav_1.png"
            alt
          />
          <div class="select">
            <ul>
              <li
                v-for="(item, index) in d"
                :key="index"
                @click="selectScroll(index)"
                :class="[current == index ? 'active' : 'selectli']"
              >
                {{ $navSelect(item.type) }}
              </li>
            </ul>
          </div>
          <div class="glass-effect"></div> <!-- 毛玻璃效果 -->
        </div>

        <!-- 极果出品结尾句 -->
        <div class="footerJ">
          <div class="yp-title">
            <img src="@/assets/pingxuan2024/pc/images/yp.png" alt="">
          </div>
          <div class="footerWei">
            <span>以上，就是我们对2024年所有数码产品的总结，也是我们想分享给大家的实用科技好物！希望能给大家在生活和工作中带来一些帮助~</span>
            <div>得益于工作的便利性，极果君能够体验到各种好玩有趣的数码科技产品。我们深耕每个行业、深度探索每一款产品，每一次分享我们都力图做到最好，只是希望能够对你有用!</div>
            <div>这些奖项不仅是对过去一年科技成就的总结，更是对未来科技发展的期待。让我们共同期待2025年，新一代科技产品继续为我们的生活带来惊喜和改变！</div>
          </div>
          <div class="quotation"></div>
          <!-- 链接 -->
          <v-link></v-link>
        </div>

        <!-- footer -->
        <v-footer></v-footer>
      </div>

    </div>

  </div>
</template>
<script>
import d from "@/assets/pingxuan2024/data/index.js";
import vHeader from "../components/header.vue";
import vFooter from "../components/footer.vue";
import vLink from "../components/link.vue";
import vPart from "../components/part.vue";
import vPart2 from "../components/partV2.vue";
import vPreface from "../components/preface.vue";
import throttle from "lodash/throttle";

export default {
  data() {
    return {
      d,
      current: 0,
      nav: [],
    };
  },
  components: {
    vPart2,
    vHeader,
    vFooter,
    vLink,
    vPart,
    vPreface,
  },
  methods: {
    selectScroll(i) {
      this.current = i;
      // 获取右侧的模块距离顶部的距离  点击按钮之后 滑动哪个，哪个到顶部
      let scroll = document.querySelector(".productScroll" + i);
      // 获取页面模块的滚动距离
      window.scrollTo({
        top: scroll.offsetTop + 200,
        behavior: "smooth",
      });
    },
    // 滚动
    handlescroll() {
      // 页面滚动时候,模块的滑动距离
      var scrollTop =
        window.pageYOffset + 1 ||
        document.documentElement.scrollTop + 1 ||
        document.body.scrollTop + 1;
      this.gettop(scrollTop);
    },
    // 获取到页面滚动距离之后,改变侧边导航栏样式
    gettop(top) {
      let nav = document.getElementsByClassName("nav")[0];
      if (top >= 500 && top <= 24552) {
        nav.style.display = "block";
        nav.style.position = "fixed";
        nav.style.top = "50px";
      } else if (top <= 400) {
        nav.style.display = "none";
      } else if (top >= 24590) {
        nav.style.display = "none";
      }
      let index = this.current;
      for (let i = 0, len = this.nav.length; i <= len; i++) {
        if (top >= this.nav[i]) {
          index = i;
        }
      }
      this.current = index;
    },
  },
  computed: {},
  mounted() {
    this.d.forEach((item, index) => {
      let leftScroll =
        document.querySelector(".productScroll" + index).offsetTop + 100;
      this.nav.push(leftScroll);
    });

    this.handlescroll();
    // 监听事件+防抖
    window.addEventListener(
      "scroll",
      throttle(this.handlescroll, 300, false),
      true
    );
  },
};
</script>

<style lang='scss' scoped>
body {
  min-width: 1107px;
  font-family: "SimHei", "黑体", sans-serif;
}
.box {
  background-color: #f3f3f3;
}
.headerBg {
  width: 100%;
}

.down{
  background-color: #3C1383;
  position: relative;
  background-image: url("~@/assets/pingxuan2024/pc/images/bg-ripple.png");


}
.viewport {
  width: 1000px;
  margin: 0 auto;
  padding-top: 10px;
  box-sizing: border-box;
  position: relative;
}

// 产品
.product5 {
  width: 100%;
  margin-top: 64px;
}
// 产品名称
.product5 {
  width: 100%;
}

// 结尾
.footerJ {
  padding-top: 30px;
  box-sizing: border-box;
  position: relative;
  width: 1000px;
  height: 564px;

  .yp-title{
    img{
      display: block;
      width: 200px;
      margin: 0 auto;
    }
  }

}
.footerWei {
  margin: 0 auto;
  width: 892px;
  height: 158px;
  font-size: 14px;
  font-family: "SimHei", "黑体", sans-serif;
  line-height: 35px;
  text-align:justify;
  margin-top: 20px;
  color: #FFF8BD;
}

.quotation{
    width: 37px;
    height: 31px;
    background: url("~@/assets/pingxuan2022/pc/images/quotation.png") no-repeat;
    background-size: 100%;
    margin: 11px 0 0 892px;
  }

.footer-line{
  width: 100%;
  height: 26px;
  background: #DF293F;
}

// 导航
.nav {
  width: 107px;
  height: 801px;
  position: absolute;
  z-index: 10;
  right: 50%;
  transform: translateX(612px);
}
.nav .navImg {
  width: 100%;
  height: 100%;
}
.nav .select {
  position: absolute;
  top: 124px;
  width: 107px;
  height: 648px;
  padding-top: 19px;
  box-sizing: border-box;
}
.select :hover {
  cursor: pointer;
}
.select ul::-webkit-scrollbar {
  display: none;
}

.select ul {
  width: 100%;
  height: 618px;
  -ms-overflow-style: none; /* IE 和 Edge */
  scrollbar-width: none; /* Firefox */
  overflow-y: scroll;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  text-align: center;
  // text-align: justify;
  font-size: 16px;
  font-weight: 400;
  color: #fff;
  li{
    line-height: 30px;
  }
}
.bg-star{
  position: absolute;
  left: 50%;
  top: 259px;
  margin-left: -960px;
  width: 404px;
  height: 510px;
  background: url("~@/assets/pingxuan2024/pc/images/bg-star.png") no-repeat center center;
  background-size: 100%;
  opacity: 0.41;
}

.bg-right{
  position: absolute;
  right: 50%;
  top: 159px;
  margin-right: -870px;
  width: 404px;
  height: 510px;
  background: url("~@/assets/pingxuan2024/pc/images/bg-star.png") no-repeat center center;
  background-size: 100%;
  opacity: 0.41;
}

.bg-pro{
  position: absolute;
  left: 50%;
  top: 977px;
  margin-left: 680px;
  width: 37px;
  height: 549px;
  background: url("~@/assets/pingxuan2024/pc/images/bg-pro.png") no-repeat center center;
  background-size: 100%;
  background-size: contain;
}

.bg-year{
  position: absolute;
  left: 50%;
  bottom: 600px;
  margin-left: -798px;
  width: 43px;
  height: 536px;
  background: url("~@/assets/pingxuan2024/pc/images/bg-year.png") no-repeat center center;
  background-size: contain;
}

.bg-ripple{
  position: absolute;
  left: 50%;
  top: 0px;
  margin-left: 692px;
  width: 266px;
  height: 100%;
  background: url("~@/assets/pingxuan2024/pc/images/bg-ripple.png") repeat-y center 0;
  background-size: 100%;
  opacity: 0.3;
}
.active {
  color: #38ffd0;
}

@media screen and (min-width: 1980px) {
    .bg-ripple{
      display: none;
    }
}

/* 毛玻璃效果 */
.glass-effect {
  //position: absolute;
  //bottom: 0;
  //left: 0;
  //right: 0;
  //height: 80px; /* 高度 */
  //background: linear-gradient(to bottom, rgba(255, 255, 255, 0), #3C1383); /* 渐变背景 */
  //backdrop-filter: blur(1px); /* 毛玻璃模糊效果 */
  //pointer-events: none; /* 防止遮挡滚动条 */
}


</style>
